/*
  Scheda prodotto: pesi raggruppati in fasce (Figma Sabrina, ottobre 2026).
  Si attiva solo se un'opzione ha almeno 12 valori, tutti nel formato "N kg".
  Non sposta e non ricrea i radio del tema: aggiunge le linguette e nasconde le etichette fuori fascia,
  cosi' varianti, prezzo, carrello e tracciamento restano quelli originali.
  Davide | SEO Specialist di Wider View
*/
(() => {
	const KG = /^\s*(\d+(?:[.,]\d+)?)\s*kg\s*$/i;
	const MIN_VALUES = 12;
	const fmt = (n) => String(n).replace('.', ',');

	function groupFieldset(fieldset) {
		if (fieldset.classList.contains('product-form__controls--colors')) return;
		const box = fieldset.querySelector('.product-form__controls-group');
		if (!box) return;
		const inputs = Array.from(box.querySelectorAll('input[type="radio"]'));
		if (inputs.length < MIN_VALUES) return;

		const values = inputs.map((input) => {
			const match = KG.exec(input.value);
			return match ? parseFloat(match[1].replace(',', '.')) : NaN;
		});
		if (values.some(Number.isNaN)) return;

		const max = Math.max(...values);
		const cuts = max > 30 ? [10, 30] : [10];
		const bands = [];
		inputs.forEach((input, i) => {
			let band = cuts.findIndex((cut) => values[i] <= cut);
			if (band < 0) band = cuts.length;
			const label = box.querySelector(`label[for="${CSS.escape(input.id)}"]`);
			(bands[band] = bands[band] || []).push({ input, label, value: values[i] });
		});
		const list = bands.filter(Boolean);
		if (list.length < 2) return;

		let tabs = fieldset.querySelector('.wv-weight-tabs');
		if (!tabs) {
			tabs = document.createElement('div');
			tabs.className = 'wv-weight-tabs';
			tabs.setAttribute('role', 'group');
			tabs.setAttribute('aria-label', 'Fasce di peso');
			box.before(tabs);
		}
		tabs.textContent = '';

		const show = (index) => {
			list.forEach((items, j) => {
				items.forEach(({ label }) => label && label.toggleAttribute('data-wv-hidden', j !== index));
				tabs.children[j].setAttribute('aria-pressed', j === index ? 'true' : 'false');
			});
		};

		list.forEach((items, j) => {
			const vals = items.map((item) => item.value);
			const button = document.createElement('button');
			button.type = 'button';
			button.className = 'wv-weight-tabs__tab';
			button.textContent = `${fmt(Math.min(...vals))}-${fmt(Math.max(...vals))} kg`;
			button.addEventListener('click', () => show(j));
			tabs.append(button);
		});

		const selected = list.findIndex((items) => items.some(({ input }) => input.checked));
		show(selected < 0 ? 0 : selected);
		fieldset.classList.add('wv-weight-grouped');
	}

	// Voto Judge.me con la virgola (4.9 -> 4,9): il valore resta quello del widget, cambia solo il separatore.
	function formatRating(root) {
		root.querySelectorAll('.main-product .jdgm-all-reviews-rating__score').forEach((score) => {
			const text = score.textContent.trim();
			if (/^\d+\.\d+$/.test(text)) score.textContent = text.replace('.', ',');
		});
	}

	function watchRating(root) {
		formatRating(root);
		root.querySelectorAll('.main-product .main-product__app-block').forEach((block) => {
			if (block.dataset.wvObserved) return;
			block.dataset.wvObserved = 'true';
			// Judge.me puo' ridisegnare il widget dopo il caricamento.
			new MutationObserver(() => formatRating(block)).observe(block, { childList: true, subtree: true, characterData: true });
		});
	}

	// "Prezzo piu' basso negli ultimi 30 giorni" (app Omnibus): il prezzo ha gia' il simbolo €, si toglie il codice "EUR"
	// che su telefono mandava la riga a capo (riunione 14/10/2026). Cambia solo il testo, il valore resta quello dell'app.
	function omnibusNoCurrencyCode(el) {
		const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
		while (walker.nextNode()) {
			const node = walker.currentNode;
			if (/\bEUR\b/.test(node.nodeValue)) node.nodeValue = node.nodeValue.replace(/\s*\bEUR\b/g, '');
		}
	}

	function watchOmnibus(root) {
		root.querySelectorAll('.main-product omnibus-lowest-price').forEach((el) => {
			omnibusNoCurrencyCode(el);
			// Si osserva il blocco app: l'app puo' ricreare l'elemento al cambio variante.
			const block = el.closest('.shopify-app-block') || el.parentElement;
			if (block.dataset.wvObserved) return;
			block.dataset.wvObserved = 'true';
			new MutationObserver(() => omnibusNoCurrencyCode(block)).observe(block, { childList: true, subtree: true, characterData: true });
		});
	}

	// Codice prodotto (SKU) come ultima voce delle Specifiche tecniche (riunione 14/10/2026): segue la variante scelta.
	function updateSku(section) {
		const field = section.querySelector('[data-wv-sku]');
		const input = section.querySelector('form[action*="/cart/add"] input[name="id"]');
		const json = section.querySelector('variant-radios script[type="application/json"], variant-selects script[type="application/json"]');
		if (!field || !input || !json) return;
		let variants = [];
		try { variants = JSON.parse(json.textContent); } catch (e) { return; }
		const variant = variants.find((v) => String(v.id) === String(input.value));
		if (!variant) return;
		field.textContent = variant.sku || '';
		field.closest('.specs-list__item').hidden = !variant.sku;
	}

	// Prezzo piu' basso negli ultimi 30 giorni al cambio variante (15/10/2026): l'app Omnibus lo scrive solo al caricamento
	// della pagina, per la variante iniziale. Shopify lo calcola gia' giusto per ogni variante: si chiede la sezione
	// della variante scelta (Section Rendering API) e si sostituisce solo l'elemento dell'app. Il valore resta quello dell'app.
	let omnibusRequest = 0;
	async function refreshOmnibus(section) {
		const current = section.querySelector('omnibus-lowest-price');
		const input = section.querySelector('form[action*="/cart/add"] input[name="id"]');
		const wrapper = section.closest('.shopify-section');
		if (!current || !input || !wrapper || current.dataset.variantId === String(input.value)) return;
		const variantId = String(input.value);
		const sectionId = wrapper.id.replace('shopify-section-', '');
		const request = ++omnibusRequest;
		try {
			const response = await fetch(`${location.pathname}?variant=${encodeURIComponent(variantId)}&section_id=${encodeURIComponent(sectionId)}`);
			if (!response.ok || request !== omnibusRequest) return;
			const html = await response.text();
			if (request !== omnibusRequest) return;
			const fresh = new DOMParser().parseFromString(html, 'text/html')
				.querySelector(`omnibus-lowest-price[data-variant-id="${CSS.escape(variantId)}"]`);
			const now = section.querySelector('omnibus-lowest-price');
			if (fresh && now) now.replaceWith(document.importNode(fresh, true));
		} catch (e) {
			// Senza rete resta il valore precedente, come prima di questa modifica.
		}
	}

	function watchSku(root) {
		root.querySelectorAll('.main-product').forEach((section) => {
			if (section.dataset.wvSkuObserved) return;
			section.dataset.wvSkuObserved = 'true';
			// Il tema aggiorna l'id della variante nel form subito dopo il cambio: si legge al giro successivo.
			section.addEventListener('change', () => setTimeout(() => {
				updateSku(section);
				refreshOmnibus(section);
			}, 50));
		});
	}

	// Galleria su telefono (Figma): frecce sull'immagine grande, collegate allo slider Swiper del tema.
	const ARROWS = {
		prev: ['Immagine precedente', 'M12.5 15L7.5 10L12.5 5'],
		next: ['Immagine successiva', 'M7.5 15L12.5 10L7.5 5'],
	};

	function galleryArrows(root) {
		root.querySelectorAll('.main-product .js-media-list').forEach((list) => {
			if (list.querySelector(':scope > .wv-gallery-arrow')) return;
			if (list.querySelectorAll('.swiper-slide').length < 2) return;
			const buttons = Object.entries(ARROWS).map(([dir, [label, path]]) => {
				const button = document.createElement('button');
				button.type = 'button';
				button.className = `wv-gallery-arrow wv-gallery-arrow--${dir}`;
				button.setAttribute('aria-label', label);
				button.innerHTML = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true" focusable="false"><path d="${path}" stroke="currentColor" stroke-linecap="round"/></svg>`;
				button.addEventListener('click', () => {
					if (!list.swiper) return;
					if (dir === 'prev') list.swiper.slidePrev();
					else list.swiper.slideNext();
				});
				list.append(button);
				return button;
			});
			const [prev, next] = buttons;
			const sync = () => {
				const swiper = list.swiper;
				if (!swiper || swiper.params.loop) return;
				prev.disabled = swiper.isBeginning;
				next.disabled = swiper.isEnd;
			};
			// Lo slider del tema puo' inizializzarsi dopo questo script.
			let tries = 0;
			const hook = () => {
				if (list.swiper) {
					list.swiper.on('slideChange', sync);
					sync();
				} else if (tries++ < 40) {
					setTimeout(hook, 250);
				}
			};
			hook();
		});
	}

	function watchGallery(root) {
		galleryArrows(root);
		root.querySelectorAll('.main-product [data-section^="product-media-"]').forEach((media) => {
			if (media.dataset.wvObserved) return;
			media.dataset.wvObserved = 'true';
			// Su alcuni prodotti il tema riscrive la galleria al cambio variante: si rimettono le frecce.
			new MutationObserver(() => galleryArrows(media)).observe(media, { childList: true });
		});
	}

	function init(root) {
		watchRating(root);
		watchGallery(root);
		watchOmnibus(root);
		watchSku(root);
		root.querySelectorAll('.main-product variant-radios').forEach((picker) => {
			picker.querySelectorAll('fieldset').forEach(groupFieldset);
			if (picker.dataset.wvObserved) return;
			picker.dataset.wvObserved = 'true';
			// Il tema puo' riscrivere il selettore dopo il cambio variante: si riapplica il raggruppamento.
			new MutationObserver(() => picker.querySelectorAll('fieldset').forEach(groupFieldset))
				.observe(picker, { childList: true });
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', () => init(document));
	} else {
		init(document);
	}
	document.addEventListener('shopify:section:load', (event) => init(event.target));
})();